
import SelectDinamico from "../../SelectDinamico";
import ConsultaComprador from "../../../../lib/json/consultas/CompradorSelect.json"

function SelectComprador({campoComprador, changeComprador, queryComprador, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, campoValue="Y1_USER"}){
    const consulta = queryComprador || ( loadDefault ? ConsultaComprador.consulta + " WHERE Y1_FILIAL = FILIAL(SY1) AND D_E_L_E_T_ <> '*' " : '' )
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const compradorValue = bindItem ? bindItem[field] : campoComprador;
    
    return (
        <SelectDinamico
            label="Comprador"
            cText="Y1_COD + ' - ' + item.Y1_NOME"
            cValue={campoValue}
            campoValue={compradorValue}
            consulta={consulta}
            tabela={ConsultaComprador.tabelas}
            isMultiplo={false}
            showNoFilter={false}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeComprador(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectComprador;